function initMap() {

    const uluru = {
        lat: 45.764938, lng: 4.858470
    };

    const map = new google.maps.Map(document.getElementById("map"), {
        disableDefaultUI: true,
        zoom: 16,
        center: uluru,
        styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
    });

    var svg_icon = [
        '<?xml version="1.0" encoding="UTF-8"?>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="30.2769" height="56.6951" viewBox="0 0 30.2769 56.6951">',
        '<defs><style>.d{fill:#ac9432;}</style></defs>',
        '<g id="a"/><g id="b"><g id="c">',
        '<path class="d" d="M15.1376,0C6.7768,0,0,6.7781,0,15.1359c0,7.588,9.1811,28.5698,13.7317,40.3734,.4633,1.2067,1.8416,1.9928,2.7915-.1893,3.9779-9.1301,13.7537-33.4341,13.7537-40.1837-.0004-8.3587-6.7772-15.1363-15.1393-15.1363Zm0,25.8837c-5.8528,0-10.5935-4.7451-10.5935-10.5927,0-5.8519,4.7442-10.5927,10.5935-10.5927s10.5927,4.7437,10.5927,10.5927c.0008,5.8493-4.7433,10.5927-10.5927,10.5927Z"/>',
        '</g></g></svg>'
    ].join('\n');

    const marker = new google.maps.Marker({
        position: uluru,
        map: map,
        icon: { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg_icon), scaledSize: new google.maps.Size(30, 56) },
        url: 'https://goo.gl/maps/HWnEEbBy6bJg7WBi7',
        animation: google.maps.Animation.DROP
    });

    google.maps.event.addListener(marker, 'click', function () {
        //window.location.href = marker.url;
        window.open(marker.url, '_blank');
    });

    // @TODO trouver un meilleur endroit où faire ça...
    jQuery('.wp-google-wr a').html('Donnez votre avis')
    jQuery('.wp-google-stars').on('click', function(){
        //console.log('click google stars');
        jQuery('.wp-google-wr a').trigger('click');
    })
}

window.initMap = initMap;